import { memo, useMemo } from 'react';
import { formatSeconds } from '@dtvgo/date-utils';
import DotTooltip from './DotTooltip.js';
import { ProgressBarClassNames, COLOR_BLUE } from './utils.js';
import { useMouseOverProgress } from './ProgressBarContext.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/slider';
import '@dtvgo/tooltip';
import '@dtvgo/classnames';

/* External */
function MouseOver(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$tooltipBgColor = _ref.tooltipBgColor,
    tooltipBgColor = _ref$tooltipBgColor === void 0 ? COLOR_BLUE : _ref$tooltipBgColor,
    _ref$formatTooltip = _ref.formatTooltip,
    formatTooltip = _ref$formatTooltip === void 0 ? formatSeconds : _ref$formatTooltip;
  var mouseOverProgress = useMouseOverProgress();
  return /*#__PURE__*/jsx(DotTooltip, {
    className: ProgressBarClassNames.element('mouse-over', className),
    placement: placement,
    tooltipBgColor: tooltipBgColor,
    value: mouseOverProgress,
    children: useMemo(function () {
      return formatTooltip(mouseOverProgress);
    }, [formatTooltip, mouseOverProgress])
  });
}
var MouseOver$1 = /*#__PURE__*/memo(MouseOver);

export { MouseOver$1 as default };
//# sourceMappingURL=MouseOver.js.map
